import React, { useState } from 'react';
import { Textarea, TextareaGroup, TextareaSlot } from '@fiverr-private/forms';
import { Button, IconButton } from '@fiverr-private/button';
import { CopyIcon } from '@fiverr-private/visuals';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { AppI18n, appTranslate } from '../../../../i18n';
import { textareaStyles, textareaWrapperStyles } from './styles.ve.css';
import { PencilIcon } from './PencilIcon';

interface Props {
    value: string;
    isBriefChanged: boolean;
    onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onSuggestionsUpdate: () => void;
    onCopy: () => void;
}

export const BriefBox = ({ value, isBriefChanged, onSuggestionsUpdate, onChange, onCopy }: Props) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <Container position="relative" height={{ default: '250px', md: '400px' }}>
            <Stack
                position="absolute"
                top="1px"
                left="1px"
                justifyContent="spaceBetween"
                width="calc(100% - 16px)"
                background="white"
                borderRadius="lg"
                height="40px"
                alignItems="flexEnd"
                paddingLeft="4"
            >
                <Heading as="h6">
                    <AppI18n k="brief_box.title" />
                </Heading>
                <PencilIcon isFocused={isFocused} />
            </Stack>
            <TextareaGroup height="100%" className={textareaWrapperStyles}>
                <Textarea
                    flex="1"
                    width="100%"
                    className={textareaStyles}
                    value={value || ''}
                    onChange={onChange}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                />
                <TextareaSlot position="bottom" width="100%" hidden={{ default: false, md: true }}>
                    <Container width="100%" display="flex" alignItems="center" justifyContent="spaceBetween">
                        <IconButton
                            aria-label={appTranslate('brief_box.copy_label') as string}
                            variant="ghost"
                            onClick={onCopy}
                        >
                            <CopyIcon />
                        </IconButton>
                        <Button onClick={onSuggestionsUpdate} disabled={!isBriefChanged || value?.length === 0}>
                            <AppI18n k="brief_box.button_text" />
                        </Button>
                    </Container>
                </TextareaSlot>
            </TextareaGroup>
        </Container>
    );
};
